import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle } from 'lucide-react';
export function Benefits() {
  const benefits = ['Entenderás cómo funciona Amazon FBA', 'Sabrás qué vender', 'Reducirás errores', 'Tendrás claridad en cada paso', 'Avanzarás con seguridad'];
  return <section className="bg-brand-white py-20 px-6" data-id="element-13">
      <div className="max-w-3xl mx-auto" data-id="element-14">
        <FadeIn data-id="element-15">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-brand-green mb-12" data-id="element-16">
            Lo que lograrás con este sistema:
          </h2>
        </FadeIn>

        <div className="bg-brand-beige rounded-3xl p-8 md:p-12" data-id="element-17">
          <div className="space-y-6" data-id="element-18">
            {benefits.map((benefit, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-19">
                <div className="flex items-center gap-4" data-id="element-20">
                  <CheckCircle className="w-6 h-6 text-brand-green flex-shrink-0" data-id="element-21" />
                  <p className="text-xl text-brand-text font-medium" data-id="element-22">
                    {benefit}
                  </p>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}